import { Trophy, Bullseye, Star, Chat } from "../components/images/svg/icons";

export const Tips = [
  {
    icon: Trophy,
    title: "TIPS_TITLE_1",
    description: "TIPS_TITLE_1_DESC",
  },
  {
    icon: Bullseye,
    title: "TIPS_TITLE_2",
    description: "TIPS_TITLE_2_DESC",
  },
  {
    icon: Star,
    title: "TIPS_TITLE_3",
    description: "TIPS_TITLE_3_DESC",
  },
  {
    icon: Chat,
    title: "TIPS_TITLE_4",
    description: "TIPS_TITLE_4_DESC",
  },
];
